import React,{useState,useEffect} from 'react';
import {sendMessage} from "../../containers/TDP/TDPWebsiteFunctions";
import {connect} from "react-redux";
import {updateDataStore} from "../../actions/foundationActions";
import {gsap,TimelineMax,Power4 } from "gsap";


const TDPContactForm = () => {
    useEffect(() => {
        let element = document.getElementsByClassName('tdp-contact-element');
        for (let i = 0; i < element.length; ++i) {
            gsap.set(element, {x:50,opacity:0});
        }
        let myTimeline = new TimelineMax();
        myTimeline.staggerTo(element, 1, {x:0,opacity:1,ease:Power4.easeOut,delay:.1}, .1);
        //eslint-disable-next-line
    },[]);

    let [name,setName] = useState(null);
    let [email,setEmail] = useState(null);
    let [subject,setSubject] = useState(null);
    let [body,setBody] = useState("");
    let [site] = useState("TDP");
    let [status,setStatus] = useState("preSend");
    let [error,setError] = useState(null);

    const preSendForm= (
        <div className="column w-100 first contact_form_outer tdpLoginform tdp-contact-element" id="tdpContactForm" style={{height:465}}>
            <form name="frcontact" className="contact-form tdpLoginform" style={{height:435,width:1100}} method="post">
                <h2>We'd Like to Hear From You!</h2>
                <p className="column dt-sc-one-third first tdp-contact-element">
                    <input id="name" name="txtname" type="text" placeholder="Your Name" required="" onChange={(evt)=>setName(evt.currentTarget.value)} />
                </p>
                <p className="column dt-sc-one-third tdp-contact-element">
                    <input id="email" name="txtemail" type="email" placeholder="Your Email" required="" onChange={(evt)=>setEmail(evt.currentTarget.value)} />
                </p>
                <p className="column dt-sc-one-third tdp-contact-element">
                    <input id="subject" name="txtsubject" type="text" placeholder="Subject: I have a question" required="" onChange={(evt)=>setSubject(evt.currentTarget.value)} />
                </p>
                <br/><br/>
                <p className="mt-4 tdp-contact-element">
                    <textarea id="comment" name="txtmessage" placeholder="Message" onChange={(evt)=>setBody(evt.currentTarget.value)} value={body}> </textarea>
                </p>
                <div id="ajax_contact_msg">{error}</div>
                <p>
                    <button name="submit" type="button" id="submit" className="dt-sc-button medium tdp-contact-element" value="Send Email" onClick={()=>sendMessage(name,email,subject,body,site,()=>setStatus("received"),()=>setError("We had a problem sending your messsage. Please Try Again."))}>Submit</button>
                </p>
            </form>
        </div>
    );

    //eslint-disable-next-line
    return (status === "received"
            ? <div className="column w-100 first contact_form_outer"><div style={{height:50,backgroundColor:"white"}}>Thanks! We'll be in touch sooon</div></div>
            : preSendForm
    )
};

const mapStateToProps = (state) =>{
    return {
        appSettings:state.appSettings,
        dataStore:state.dataStore,
    };
};

export default connect(mapStateToProps,{
    updateDataStore
})(TDPContactForm);
